export default __webpack_public_path__ + "static/media/Java1.d90ec7bb.png";